import { useFlag } from '@modernloop/shared/feature-flag';

import { BoolOrgPref } from 'src/generated/mloop-graphql';

import { useOrgPrefBoolTyped } from 'src/hooks/api/org';

/**
 * Returns whether AI task-agent features should be available for the current user and org.
 */
export default function useIsAiTaskEnabled(): boolean {
  const aiTaskAgentsEnabled = useFlag('AI_TASK_AGENTS');
  const aiAgentsEnabled = useFlag('AI_ENABLED');
  const [orgAiEnabled] = useOrgPrefBoolTyped(BoolOrgPref.BoolAiEnabledForOrg);

  return aiTaskAgentsEnabled && aiAgentsEnabled && orgAiEnabled === true;
}
